/* eslint-disable no-restricted-syntax */
import { useCallback, useEffect, useState } from 'react'
import { snakeToCamel } from '~utils'
import { OpenSeaAsset, OpenSeaAssetParams } from './types'

const url = (contactAddress: string, tokenId: string) =>
  `https://api.opensea.io/api/v1/asset/${contactAddress}/${tokenId}/`

const useOpenSeaAsset = (params: OpenSeaAssetParams & { lazy?: boolean }): OpenSeaAsset => {
  const [asset, setAsset] = useState<OpenSeaAsset>(null)

  const getAsset = useCallback(async () => {
    setAsset(null)

    const data = await (await fetch(url(params.contactAddress, params.tokenId))).json()

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formatted: any = {}

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        formatted[snakeToCamel(key)] = data[key]
      }
    }

    setAsset(formatted)
  }, [params.contactAddress, params.tokenId])

  useEffect(() => {
    if (params.lazy) return
    getAsset()
  }, [getAsset, params.lazy])

  return asset
}

export default useOpenSeaAsset
